import React, { useMemo, useCallback, useState, useReducer } from "react";
import './style.scss';
import PlayerAndDrop from "./player-and-drop";

export default function LeafGame() {

    const DATA = useMemo(() => {
        return [
            {
                label: 'dąb',
                audio: '/tasks/202/dab.png',
            },
            {
                label: 'jesion',
                audio: '/tasks/202/jesion.png',
            },
            {
                label: 'klon',
                audio: '/tasks/202/klon.png',
            },
            {
                label: 'miłorząb',
                audio: '/tasks/202/milorzab.png',
            },
            {
                label: 'olcha',
                audio: '/tasks/202/olcha.png',
            }
        ]
    }, [])

    const RANDOM_DATA = useMemo(() => {
        return [...DATA].sort(() => Math.random() - .5)
    }, [DATA]);

    const [activeWord, setActiveWord] = useState('')
    const [correctCount, addCorrect] = useReducer((state: number) => {
        return ++state;
    }, 0)

    const onDragStart = useCallback((e: React.DragEvent) => {
        e.dataTransfer.setData('text', e.currentTarget.id)
        e.dataTransfer.dropEffect = 'move';
        e.dataTransfer.setData('text', e.currentTarget.id);

        setActiveWord(e.currentTarget.id)

    }, [])

    const onDragEnd = useCallback((e) => {
        setTimeout(() => {
            setActiveWord('')
        }, 1000)
    }, [setActiveWord])

    const onCorrect = useCallback((id: string) => {
        addCorrect()
    }, [])

    return (
        <>
            <div className='leaf-game'>
                <div className="player-list">
                    {
                        DATA.map((e, index) => {
                            return (
                                <React.Fragment key={index}>
                                    <PlayerAndDrop
                                        audio={e.audio}
                                        answer={e.label}
                                        activeWord={activeWord}
                                        onCorrect={onCorrect}
                                    />
                                </React.Fragment>
                            )
                        })
                    }

                </div>
                <div className="pickzones">

                    {
                        RANDOM_DATA.map((e, index) => {
                            return (
                                <React.Fragment key={index}>
                                    <div className="pickzone"
                                        id={e.label}
                                        draggable={true}
                                        onDragStart={onDragStart}
                                        onDragEnd={onDragEnd}
                                    >
                                        <span
                                        >{e.label}</span>
                                    </div>
                                </React.Fragment>
                            )
                        })
                    }
                </div>
            </div>
            {(correctCount === DATA.length) && <p>Gratulacje!</p>}
        </>
    )
}
